export default __webpack_public_path__ + "static/media/c002-PPII-8.bcad60a5.svg";